var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from 'mobx';
import { client } from 'lib/apollo-client';
import { customerAgent } from 'lib/customer-agent';
import { authService } from 'services/auth';
import datadog from 'utils/datadog';
import localStorage from '../utils/localStorageUtils';
let AuthenticationStore = (_class = class AuthenticationStore {
  async logout() {
    // Clear the host Apollo cache before tearing down the session. Redundant in the happy path
    // (keycloak.logout() triggers a full-page redirect that drops the cache anyway), but protects
    // any future non-navigating logout flow (session timeout, account switch) from leaking the
    // previous user's data. Best-effort: if clearStore rejects (e.g. an in-flight query errors
    // out) swallow it so the localStorage cleanup, the Agent session teardown, and the Keycloak
    // logout redirect below still run — the user is leaving either way.
    await client.clearStore().catch(error => {
      datadog.dispatchGenericErrorLog({
        log: {
          from: 'AuthenticationStore.logout',
          name: 'apollo_clear_store_failed',
          message: 'client.clearStore() rejected during logout'
        },
        error: error instanceof Error ? error : new Error('non-Error rejection')
      });
    });
    localStorage.delete('panelId');
    localStorage.delete('id');
    customerAgent.endSession();
    // NOTE: user-scoped MobX stores (UserStore/PanelStore/FilterStore) are reset by the full-page
    // reload that authService.logout() triggers. Add explicit store resets here if a non-navigating
    // logout flow is ever introduced (no reset seam exists on those stores today).
    await authService.logout();
  }
}, _applyDecoratedDescriptor(_class.prototype, "logout", [action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _class);
export default new AuthenticationStore();